import { Store } from '../store.model';
import { AppState } from './app.model';

export class AppSelectors {
  static state = (store: Store): AppState => store.app;
}
